export default {
	tabs: {
		user: "User Settings",
		customer: "Customer Account",
		delivery: "Delivery Addresses",
		invoice: "Invoice Addresses",
	},
};
